<div class="client-tax-info">
  @if (stateTaxRatesFromBXR) {
    <clear-all-fields-button (clearAll)="onClearAllFields()"></clear-all-fields-button>
  }

  <!-- Current tax information section -->
  <div class="client-tax-info__section">
    <h3 class="client-tax-info__section-title">{{ content?.header1 }}</h3>

    <!-- Annual taxable income after deductions -->
    <div class="client-tax-info__field">
      <label class="client-tax-info__label">
        {{ content?.subheader1 }}
        <ngx-axs-icon
          axsType="questionOutline"
          axsAriaLabel="information"
          [axsWidth]="16"
          class="client-tax-info__icon"
          (click)="infoIconOnClick('clientTax', 'sheet-field-annual-taxable-income')"
        ></ngx-axs-icon>
      </label>
      <ngx-input-number
        inputType='dollar'
        designType='compact'
        [id]="'currentIncomeInput'"
        [currentValue]="_currentIncome.toString()"
        [hintText]="incomeHelperText"
        [errorText]="currentIncomeErrorMessage"
        (click)="currentIncomeClicked()"
        (onInputChange)="onCurrentIncomeChange($event)"
      ></ngx-input-number>
    </div>

    <!-- Tax-filing status -->
    <div class="client-tax-info__field">
      <label class="client-tax-info__label">
        {{ content?.taxfilingstatus }}
        <ngx-axs-icon
          axsType="questionOutline"
          axsAriaLabel="information"
          [axsWidth]="16"
          class="client-tax-info__icon"
          (click)="infoIconOnClick('clientTax', 'sheet-field-tax-filing-status')"
        ></ngx-axs-icon>
      </label>
      <axs-select-dropdown-beta
        #currentFilingStatusDropdown
        axs-size="small"
        [attr.axs-aria-label]="content?.taxfilingstatus"
        [attr.axs-value]="_currentFilingStatus"
        (axs-change)="onCurrentFilingStatusChange({ value: $any(currentFilingStatusDropdown).getValue() })"
      >
        <axs-select-dropdown-option-beta axs-value="" axs-disabled>Select one</axs-select-dropdown-option-beta>
        @for (option of filingStatusOptions; track option.value) {
          <axs-select-dropdown-option-beta [attr.axs-value]="option.value">{{ option.label }}</axs-select-dropdown-option-beta>
        }
      </axs-select-dropdown-beta>
    </div>

    <!-- Tax rates row -->
    <div [ngClass]="stateTaxRatesFromBXR ? 'client-tax-info__row-new' : 'client-tax-info__row'">
      <div class="client-tax-info__field"
        [ngClass]="stateTaxRatesFromBXR ? 'client-tax-info__field--equal-size' : 'client-tax-info__field--federal'">
        <label class="client-tax-info__label">
          {{ content?.federalrate }}
          <ngx-axs-icon
            axsType="questionOutline"
            axsAriaLabel="information"
            [axsWidth]="16"
            class="client-tax-info__icon"
            (click)="infoIconOnClick('clientTax', 'sheet-field-federal-tax-rate')"
          ></ngx-axs-icon>
        </label>
        <ngx-input-number
          inputType='percent'
          designType='compact'
          [id]="'currentFederalTaxInput'"
          [decimalAmount]="2"
          [max]="100"
          [currentValue]="_currentFederalTax.toString()"
          [defaultValue]="defaultCurrentFederalTax"
          [differsText]="rateDiffersText"
          [differsLinkText]="rateDiffersLinkText"
          [differsLink]="'https://advisors.vanguard.com/content/dam/fas/pdfs/FATXGD11.pdf'"
          [errorText]="currentFederalTaxErrorMessage"
          (onInputChange)="onCurrentFederalTaxChange($event)"
        ></ngx-input-number>
        @if (stateTaxRatesFromBXR && currentFederalTaxOverridden) {
        <div class="client-tax-info__note-group">
          <div class="client-tax-info__note client-tax-info__note--strong">
            <ngx-axs-icon axsType="infoSolid" axsAriaLabel="information" [axsWidth]="16"></ngx-axs-icon>
            <span>{{ content?.customOverride }}</span>
          </div>
          <button type="button" class="client-tax-info__note-sub"
            (click)="infoIconOnClick('clientTax', 'sheet-field-federal-tax-rate', 'sheet-field-federal-tax-rate-effective')">{{ content?.effectiveTaxRateActive }}</button>
          <button type="button" class="client-tax-info__note-link client-tax-info__note-link--block"
            (click)="revertCurrentFederalTax()">
            <ngx-axs-icon axsType="return" [axsDecorative]="true" [axsWidth]="16"></ngx-axs-icon>
            <span>{{ content?.revertButton }}</span>
          </button>
        </div>
        }
      </div>

      @if (stateTaxRatesFromBXR) {
      <div class="client-tax-info__field client-tax-info__field--equal-size">
        <label class="client-tax-info__label">
          {{ rothConvDetailsContent?.stateOfTaxation }}
        </label>
        <axs-select-dropdown-beta
          style="--axs-select-dropdown-max-height: 200px"
          axs-size="small"
          [attr.axs-aria-label]="rothConvDetailsContent?.stateOfTaxation"
          [attr.axs-value]="_currentStateOfTaxation"
          (axs-change)="onCurrentStateOfTaxationChange($event)"
        >
          <axs-select-dropdown-option-beta axs-value="" axs-disabled>Select one</axs-select-dropdown-option-beta>
          @for (stateCode of stateOfTaxationValues; track stateCode) {
            <axs-select-dropdown-option-beta [attr.axs-value]="stateCode" (click)="onCurrentStateOptionSelect(stateCode)">{{ stateCode }}</axs-select-dropdown-option-beta>
          }
        </axs-select-dropdown-beta>
        @if (currentStateFlags.progressiveTaxRate || !currentStateFlags.iraTaxable) {
        <div class="client-tax-info__note">
          <ngx-axs-icon axsType="infoSolid" axsAriaLabel="information" [axsWidth]="16"></ngx-axs-icon>
          <span>
            {{ currentStateFlags.iraTaxable ? content?.stateFeatures : content?.norothconversionsprefix }}
            @if (!currentStateFlags.iraTaxable) {
            <span role="button" tabindex="0" class="client-tax-info__note-link"
              (click)="infoIconOnClick('clientTax', 'sheet-field-state-tax-rate', currentStateHighlightId)"
              (keydown.enter)="infoIconOnClick('clientTax', 'sheet-field-state-tax-rate', currentStateHighlightId)">{{
              content?.norothconversionslink }}</span>
            }
            @if (!currentStateFlags.iraTaxable && currentStateFlags.progressiveTaxRate) {
            {{ content?.andhasa }}
            }
            @if (currentStateFlags.progressiveTaxRate) {
            <span role="button" tabindex="0" class="client-tax-info__note-link"
              (click)="infoIconOnClick('clientTax', 'sheet-field-state-tax-rate', currentStateHighlightId)"
              (keydown.enter)="infoIconOnClick('clientTax', 'sheet-field-state-tax-rate', currentStateHighlightId)">{{
              content?.progressiveTaxRate }}</span>
            }
          </span>
        </div>
        }
      </div>
      } @else {
      <div class="client-tax-info__field client-tax-info__field--state">
        <label class="client-tax-info__label">
          {{ content?.staterate }}
          <ngx-axs-icon axsType="questionOutline" axsAriaLabel="information" [axsWidth]="16" class="client-tax-info__icon"
            (click)="infoIconOnClick('clientTax', 'sheet-field-state-local-tax-rate')"></ngx-axs-icon>
        </label>
        <ngx-input-number inputType='percent' designType='compact' [id]="'currentStateTaxInput'" [decimalAmount]="2"
          [max]="100" [currentValue]="_currentStateTax.toString()" [errorText]="currentStateTaxErrorMessage"
          (onInputChange)="onCurrentStateTaxChange($event)"></ngx-input-number>
      </div>
      }
    </div>

    @if (stateTaxRatesFromBXR) {
      <div class="client-tax-info__row-new">
        <div class="client-tax-info__field client-tax-info__field--equal-size">
          <label class="client-tax-info__label">
            {{ rothConvDetailsContent?.stateTaxRate }}
            <ngx-axs-icon
              axsType="questionOutline"
              axsAriaLabel="information"
              [axsWidth]="16"
              class="client-tax-info__icon"
              (click)="infoIconOnClick('clientTax', 'sheet-field-state-tax-rate')"
            ></ngx-axs-icon>
          </label>
          <ngx-input-number
            inputType='percent'
            designType='compact'
            [id]="'currentStateTaxStaticInput'"
            [decimalAmount]="2"
            [max]="100"
            [currentValue]="_currentStateTaxStatic.toString()"
            (onInputChange)="onCurrentStateTaxStaticChange($event)"
          ></ngx-input-number>
          @if (currentStateTaxStaticOverridden) {
          <div class="client-tax-info__note-group">
            <div class="client-tax-info__note client-tax-info__note--strong">
              <ngx-axs-icon axsType="infoSolid" axsAriaLabel="information" [axsWidth]="16"></ngx-axs-icon>
              <span>{{ content?.customOverride }}</span>
            </div>
            <button type="button" class="client-tax-info__note-sub"
              (click)="infoIconOnClick('clientTax', 'sheet-field-state-tax-rate','sheet-field-state-tax-rate-effective')">{{ content?.effectiveTaxRateActive }}</button>
            <button type="button" class="client-tax-info__note-link client-tax-info__note-link--block"
              (click)="revertCurrentStateTaxStatic()">
              <ngx-axs-icon axsType="return" [axsDecorative]="true" [axsWidth]="16"></ngx-axs-icon>
              <span>{{ content?.revertButton }}</span>
            </button>
          </div>
          }
        </div>

        <div class="client-tax-info__field client-tax-info__field--equal-size">
          <label class="client-tax-info__label">
            {{ rothConvDetailsContent?.localTaxRate }}
            <ngx-axs-icon
              axsType="questionOutline"
              axsAriaLabel="information"
              [axsWidth]="16"
              class="client-tax-info__icon"
              (click)="infoIconOnClick('clientTax', 'sheet-field-local-tax-rate')"
            ></ngx-axs-icon>
          </label>
          <ngx-input-number
            inputType='percent'
            designType='compact'
            [id]="'currentLocalTaxInput'"
            [decimalAmount]="2"
            [max]="100"
            [currentValue]="_currentLocalTax.toString()"
            (onInputChange)="onCurrentLocalTaxChange($event)"
          ></ngx-input-number>
        </div>
      </div>
    }
  </div>

  <!-- Future tax information section -->
  <div class="client-tax-info__section">
    <h3 class="client-tax-info__section-title">{{ content?.header2 }}</h3>

    <!-- Future Taxable income at distribution -->
    <div class="client-tax-info__field">
      <label class="client-tax-info__label">
        {{ content?.subheader2 }}
        <ngx-axs-icon
          axsType="questionOutline"
          axsAriaLabel="information"
          [axsWidth]="16"
          class="client-tax-info__icon"
          (click)="infoIconOnClick('clientTax', 'sheet-field-future-taxable-income')"
        ></ngx-axs-icon>
      </label>
      <ngx-input-number
        inputType='dollar'
        designType='compact'
        [id]="'futureIncomeInput'"
        [currentValue]="_futureIncome.toString()"
        [errorText]="futureIncomeErrorMessage"
        (click)="futureIncomeClicked()"
        (onInputChange)="onFutureIncomeChange($event)"
      ></ngx-input-number>
    </div>

    <!-- Future Tax-filing status -->
    <div class="client-tax-info__field">
      <label class="client-tax-info__label">
        {{ content?.taxfilingstatus }}
        <ngx-axs-icon
          axsType="questionOutline"
          axsAriaLabel="information"
          [axsWidth]="16"
          class="client-tax-info__icon"
          (click)="infoIconOnClick('clientTax', 'sheet-field-future-tax-filing-status')"
        ></ngx-axs-icon>
      </label>
      <axs-select-dropdown-beta
        #futureFilingStatusDropdown
        axs-size="small"
        [attr.axs-aria-label]="content?.taxfilingstatus"
        [attr.axs-value]="_futureFilingStatus"
        (axs-change)="onFutureFilingStatusChange({ value: $any(futureFilingStatusDropdown).getValue() })"
      >
        <axs-select-dropdown-option-beta axs-value="" axs-disabled>Select one</axs-select-dropdown-option-beta>
        @for (option of filingStatusOptions; track option.value) {
          <axs-select-dropdown-option-beta [attr.axs-value]="option.value">{{ option.label }}</axs-select-dropdown-option-beta>
        }
      </axs-select-dropdown-beta>
    </div>

    <!-- Future Tax rates row -->
    <div [ngClass]="stateTaxRatesFromBXR ? 'client-tax-info__row-new' : 'client-tax-info__row'">
      <div class="client-tax-info__field"
        [ngClass]="stateTaxRatesFromBXR ? 'client-tax-info__field--equal-size' : 'client-tax-info__field--federal'">
        <label class="client-tax-info__label">
          {{ content?.federalrate }}
          <ngx-axs-icon
            axsType="questionOutline"
            axsAriaLabel="information"
            [axsWidth]="16"
            class="client-tax-info__icon"
            (click)="infoIconOnClick('clientTax', 'sheet-field-future-federal-tax-rate')"
          ></ngx-axs-icon>
        </label>
        <ngx-input-number
          inputType='percent'
          designType='compact'
          [id]="'futureFederalTaxInput'"
          [decimalAmount]="2"
          [max]="100"
          [currentValue]="_futureFederalTax.toString()"
          [defaultValue]="defaultFutureFederalTax"
          [differsText]="rateDiffersText"
          [differsLinkText]="rateDiffersLinkText"
          [differsLink]="'https://advisors.vanguard.com/content/dam/fas/pdfs/FATXGD11.pdf'"
          [errorText]="futureFederalTaxErrorMessage"
          (onInputChange)="onFutureFederalTaxChange($event)"
        ></ngx-input-number>
        @if (stateTaxRatesFromBXR && futureFederalTaxOverridden) {
        <div class="client-tax-info__note-group">
          <div class="client-tax-info__note client-tax-info__note--strong">
            <ngx-axs-icon axsType="infoSolid" axsAriaLabel="information" [axsWidth]="16"></ngx-axs-icon>
            <span>{{ content?.customOverride }}</span>
          </div>
          <button type="button" class="client-tax-info__note-sub"
            (click)="infoIconOnClick('clientTax', 'sheet-field-future-federal-tax-rate', 'sheet-field-future-federal-tax-rate-effective')">{{ content?.effectiveTaxRateActive }}</button>
          <button type="button" class="client-tax-info__note-link client-tax-info__note-link--block"
            (click)="revertFutureFederalTax()">
            <ngx-axs-icon axsType="return" [axsDecorative]="true" [axsWidth]="16"></ngx-axs-icon>
            <span>{{ content?.revertButton }}</span>
          </button>
        </div>
        }
      </div>

      @if (stateTaxRatesFromBXR) {
      <div class="client-tax-info__field client-tax-info__field--equal-size">
        <label class="client-tax-info__label">
          {{ rothConvDetailsContent?.stateOfTaxation }}
        </label>
        <axs-select-dropdown-beta
          style="--axs-select-dropdown-max-height: 200px"
          axs-size="small"
          [attr.axs-aria-label]="rothConvDetailsContent?.stateOfTaxation"
          [attr.axs-value]="_futureStateOfTaxation"
          (axs-change)="onFutureStateOfTaxationChange($event)"
        >
          <axs-select-dropdown-option-beta axs-value="" axs-disabled>Select one</axs-select-dropdown-option-beta>
          @for (stateCode of stateOfTaxationValues; track stateCode) {
            <axs-select-dropdown-option-beta [attr.axs-value]="stateCode" (click)="onFutureStateOptionSelect(stateCode)">{{ stateCode }}</axs-select-dropdown-option-beta>
          }
        </axs-select-dropdown-beta>
        <!-- Future scenario shows only the progressive note: a Roth conversion happens in the
             current year, so "doesn't tax roth conversions" is a current-scenario fact only. -->
        @if (futureStateFlags.progressiveTaxRate) {
        <div class="client-tax-info__note">
          <ngx-axs-icon axsType="infoSolid" axsAriaLabel="information" [axsWidth]="16"></ngx-axs-icon>
          <span>
            {{ content?.stateFeatures }}
            <span role="button" tabindex="0" class="client-tax-info__note-link"
              (click)="infoIconOnClick('clientTax', 'sheet-field-future-state-tax-rate', futureStateHighlightId)"
              (keydown.enter)="infoIconOnClick('clientTax', 'sheet-field-future-state-tax-rate', futureStateHighlightId)">{{
              content?.progressiveTaxRate }}</span>
          </span>
        </div>
        }
      </div>
      } @else {
      <div class="client-tax-info__field client-tax-info__field--state">
        <label class="client-tax-info__label">
          {{ content?.staterate }}
          <ngx-axs-icon axsType="questionOutline" axsAriaLabel="information" [axsWidth]="16" class="client-tax-info__icon"
            (click)="infoIconOnClick('clientTax', 'sheet-field-future-state-local-tax-rate')"></ngx-axs-icon>
        </label>
        <ngx-input-number inputType='percent' designType='compact' [id]="'futureStateTaxInput'" [decimalAmount]="2"
          [max]="100" [currentValue]="_futureStateTax.toString()" [errorText]="futureStateTaxErrorMessage"
          (onInputChange)="onFutureStateTaxChange($event)"></ngx-input-number>
      </div>
      }
    </div>

    @if (stateTaxRatesFromBXR) {
      <div class="client-tax-info__row-new">
        <div class="client-tax-info__field client-tax-info__field--equal-size">
          <label class="client-tax-info__label">
            {{ rothConvDetailsContent?.stateTaxRate }}
            <ngx-axs-icon
              axsType="questionOutline"
              axsAriaLabel="information"
              [axsWidth]="16"
              class="client-tax-info__icon"
              (click)="infoIconOnClick('clientTax', 'sheet-field-future-state-tax-rate')"
            ></ngx-axs-icon>
          </label>
          <ngx-input-number
            inputType='percent'
            designType='compact'
            [id]="'futureStateTaxStaticInput'"
            [decimalAmount]="2"
            [max]="100"
            [currentValue]="_futureStateTaxStatic.toString()"
            (onInputChange)="onFutureStateTaxStaticChange($event)"
          ></ngx-input-number>
          @if (futureStateTaxStaticOverridden) {
          <div class="client-tax-info__note-group">
            <div class="client-tax-info__note client-tax-info__note--strong">
              <ngx-axs-icon axsType="infoSolid" axsAriaLabel="information" [axsWidth]="16"></ngx-axs-icon>
              <span>{{ content?.customOverride }}</span>
            </div>
            <button type="button" class="client-tax-info__note-sub"
              (click)="infoIconOnClick('clientTax', 'sheet-field-future-state-tax-rate','sheet-field-future-state-tax-rate-effective')">{{ content?.effectiveTaxRateActive }}</button>
            <button type="button" class="client-tax-info__note-link client-tax-info__note-link--block"
              (click)="revertFutureStateTaxStatic()">
              <ngx-axs-icon axsType="return" [axsDecorative]="true" [axsWidth]="16"></ngx-axs-icon>
              <span>{{ content?.revertButton }}</span>
            </button>
          </div>
          }
        </div>

        <div class="client-tax-info__field client-tax-info__field--equal-size">
          <label class="client-tax-info__label">
            {{ rothConvDetailsContent?.localTaxRate }}
            <ngx-axs-icon
              axsType="questionOutline"
              axsAriaLabel="information"
              [axsWidth]="16"
              class="client-tax-info__icon"
              (click)="infoIconOnClick('clientTax', 'sheet-field-future-local-tax-rate')"
            ></ngx-axs-icon>
          </label>
          <ngx-input-number
            inputType='percent'
            designType='compact'
            [id]="'futureLocalTaxInput'"
            [decimalAmount]="2"
            [max]="100"
            [currentValue]="_futureLocalTax.toString()"
            (onInputChange)="onFutureLocalTaxChange($event)"
          ></ngx-input-number>
        </div>
      </div>
    }
  </div>
</div>
